import styled from "styled-components";
import { Button } from "../../../../../../base/buttons/button/index.js";
import { FlexMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { SearcherItem } from "../../../styled.js";
import SearcherButtonThemes from "./themes/index.js";
export const SearcherWrapperButton = styled(Button).withConfig({
    displayName: "styled__SearcherWrapperButton",
    componentId: "sc-f35f4e6b-0"
})`
	width: 100%;
	height: ${({ height ='56px'  })=>height};
	padding: 8px 16px;
	min-width: 150px;
	max-width: 160px;

	${({ theme  })=>SearcherButtonThemes[theme.id]?.SearcherWrapperButton?.()}
`;
export const SearcherItemButtonDesktop = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemButtonDesktop",
    componentId: "sc-f35f4e6b-1"
})`
	${FlexMixin({
    justify: 'flex-end'
})}
	gap: var(--division-gap);
	flex-grow: 1;

	${({ theme  })=>theme.media.up('xl')} {
		${({ $grow =false  })=>`flex-grow: ${$grow ? 1 : 0};`}
	}

	${({ theme  })=>SearcherButtonThemes[theme.id]?.SearcherItemButtonDesktop?.()}
`;
export const SearcherWrapper = styled.div.withConfig({
    displayName: "styled__SearcherWrapper",
    componentId: "sc-f35f4e6b-2"
})`
	${FlexMixin({
    direction: 'column'
})}

	${({ theme  })=>SearcherButtonThemes[theme.id]?.SearcherWrapper?.()}
`;
export const NumberTextWrapper = styled.div.withConfig({
    displayName: "styled__NumberTextWrapper",
    componentId: "sc-f35f4e6b-3"
})`
	${FlexMixin({
    direction: 'column'
})}
	align-self: center;
	flex-basis: calc(10% - var(--division-gap));
	flex-grow: 1;
	text-align: center;

	${({ theme  })=>SearcherButtonThemes[theme.id]?.NumberTextWrapper?.()}
`;

//# sourceMappingURL=styled.js.map